import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { isExternalStorageUrl } from './is-external-storage-url';

/**
 * Tags first-party requests with the app origin. Skips external object storage (S3):
 * the header is useless to S3 and, on the direct upload PUT, forces the bucket CORS to
 * allow-list it or the preflight fails and the upload dies with a masked status 0. See DEV-26988.
 */
export function OriginInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (isExternalStorageUrl(req.url)) return next(req);

  req = req.clone({
    headers: req.headers.set('ninety-origin', location.origin),
  });

  return next(req);
}
